// extracted by mini-css-extract-plugin
export var PartnersList = "styles-module--PartnersList--b577b";
export var comparison = "styles-module--comparison--acd33";
export var interest = "styles-module--interest--331ee";
export var lastTile = "styles-module--lastTile--d75c7";
export var logo = "styles-module--logo--ce6c1";
export var partner = "styles-module--partner--be297";